import { TActions } from '../../../../AppModulesWrapper';
import { defaultState } from './defaultState';
import { IPublicationPackagesState } from './types';
import {
  CHANGE_SELECTED_PACKAGE_ID,
  LOAD_PUBLISH_TERMS_SUCCESS,
  SELECT_PACKAGE,
  SELECT_PLACING_TYPE,
} from '../../../actions/publishTerms';
import { mergePublicationPackages, selectFirstPackage, selectPackageById, unselectAllPackages } from './utils';
import { EPlacingType } from '../../../types/reducers/publishTerms';

export const publicationPackages = (state: IPublicationPackagesState = defaultState, action: TActions) => {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS: {
      return mergePublicationPackages(state, action.payload.dataV2.publicationPackages.packagesList);
    }
    case CHANGE_SELECTED_PACKAGE_ID:
    case SELECT_PACKAGE: {
      return {
        ...state,
        packagesList: selectPackageById(state.packagesList, action.payload),
        changedByUser: action.type === SELECT_PACKAGE,
      };
    }
    case SELECT_PLACING_TYPE: {
      switch (action.payload) {
        case EPlacingType.balance: {
          return {
            ...state,
            packagesList: unselectAllPackages(state.packagesList),
            changedByUser: true,
          };
        }
        case EPlacingType.package: {
          const selectedPackage = state.packagesList.find(item => item.selected);

          if (selectedPackage) {
            return state;
          }

          return {
            ...state,
            packagesList: selectFirstPackage(state.packagesList),
            changedByUser: true,
          };
        }
        default: {
          throw new Error('Неизвестный тип размещения');
        }
      }
    }
    default: {
      return state;
    }
  }
};
